<template>
  <div class="card">
    <header class="bandeau-modal card-header">
    </header>
    <div class="card-content">
      <section class="has-text-centered pdb-40px">
        <p class="is-size-3 has-text-weight-bold">
          {{$t('addSchemaComptable.parametrageLibelle.paramEcriture.title')}}
        </p>
      </section>
      <b-field
        :label="label">
        <b-input v-model="libelle" ref="libelleInput"/>
      </b-field>
      <div class="columns is-multiline mgb-20px">
        <div class="column is-6">
          <p class="has-text-weight-bold is-cursor-pointer"
              @click="addText('{TYPE_PIECE}')">
            {TYPE_PIECE}
          </p>
          <p class="has-text-default">
            {{$t('addSchemaComptable.parametrageLibelle.paramEcriture.piece')}}
          </p>
        </div>
        <div class="column is-6">
          <p class="has-text-weight-bold is-cursor-pointer"
              @click="addText('{TYPE_PIECE_COURT}')">
            {TYPE_PIECE_COURT}
          </p>
          <p class="has-text-default">
            {{$t('addSchemaComptable.parametrageLibelle.paramEcriture.pieceCourt')}}
          </p>
        </div>
        <div class="column is-6">
          <p class="has-text-weight-bold is-cursor-pointer"
              @click="addText('{TIERS_COMPTABLE_NOM}')">
            {TIERS_COMPTABLE_NOM}
          </p>
          <p class="has-text-default">
            {{$t('addSchemaComptable.parametrageLibelle.paramEcriture.nom')}}
          </p>
        </div>
        <div class="column is-6">
          <p class="has-text-weight-bold is-cursor-pointer"
              @click="addText('{REFERENCE}')">
            {REFERENCE}
          </p>
          <p class="has-text-default">
            {{$t('addSchemaComptable.parametrageLibelle.paramEcriture.reference')}}
          </p>
        </div>
        <div class="column is-6">
          <p class="has-text-weight-bold is-cursor-pointer"
              @click="addText('{TIERS_COMPTABLE_JURIDIQUE}')">
            {TIERS_COMPTABLE_JURIDIQUE}
          </p>
          <p class="has-text-default">
            {{$t('addSchemaComptable.parametrageLibelle.paramEcriture.nomJuridique')}}
          </p>
        </div>
        <div class="column is-6">
          <p class="has-text-weight-bold is-cursor-pointer"
             @click="addText('{ANNONCEURS}')">
            {ANNONCEURS}
          </p>
          <p class="has-text-default">
            {{$t('addSchemaComptable.parametrageLibelle.paramEcriture.annonceurs')}}
          </p>
        </div>
        <div v-if="type !== 'ecriture'" class="column is-6">
          <p class="has-text-weight-bold is-cursor-pointer"
             @click="addText('{PERIODE}')">
            {PERIODE}
          </p>
          <p class="has-text-default">
            {{$t('addSchemaComptable.parametrageLibelle.paramEcriture.periode')}}
          </p>
        </div>
        <div v-if="type !== 'ecriture'" class="column is-6">
          <p class="has-text-weight-bold is-cursor-pointer"
             @click="addText('{PERIODE_COURT}')">
            {PERIODE_COURT}
          </p>
          <p class="has-text-default">
            {{$t('addSchemaComptable.parametrageLibelle.paramEcriture.periodeCourt')}}
          </p>
        </div>
        <div v-if="typeContrepartieTiersTva.includes(type)" class="column is-6">
          <p class="has-text-weight-bold is-cursor-pointer"
              @click="addText('{LIBELLE_PREMIERE_LIGNE_FACTURE}')">
            {LIBELLE_PREMIERE_LIGNE_FACTURE}
          </p>
          <p class="has-text-default">
            {{$t('addSchemaComptable.parametrageLibelle.paramEcriture.libelle1ereLigneFacture')}}
          </p>
        </div>
      </div>
      <div class="buttons">
        <qd-button type="is-light"
                  class="btn-modal-annuler"
                  @click="close()">
          {{$t('addSchemaComptable.parametrageLibelle.paramEcriture.exit')}}
        </qd-button>
        <qd-button type="is-info"
                  @click="save()">
          {{$t('general.button.sauvegarder')}}
        </qd-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      libelle: '',
      typeContrepartieTiersTva: ['ecritureContrepartie', 'ecritureTiers', 'ecritureTva'],
    };
  },
  computed: {
    label() {
      if (this.type === 'ecriture') {
        return this.$t('addSchemaComptable.parametrageLibelle.ecriture');
      }
      if (this.type === 'ecritureTiers') {
        return this.$t('addSchemaComptable.parametrageLibelle.ecritureTiers');
      }
      if (this.type === 'ecritureTva') {
        return this.$t('addSchemaComptable.parametrageLibelle.ecritureTva');
      }
      if (this.type === 'ecritureContrepartie') {
        return this.$t('addSchemaComptable.parametrageLibelle.ecritureContrepartie');
      }
      if (this.type === 'ecritureAcompte') {
        return this.$t('addSchemaComptable.parametrageLibelle.ecritureAcompte');
      }
      return '';
    },
  },
  methods: {
    addText(text) {
      this.libelle += text;
    },
    close() {
      this.$emit('close');
    },
    save() {
      this.$emit('save', {
        value: this.libelle,
        type: this.type,
      });
      this.close();
    },
  },
  mounted() {
    this.$refs.libelleInput.focus();
    this.libelle = this.value ? this.value : '';
  },
};
</script>

<style>

</style>
